import { render } from "./MainFooterBlock.vue?vue&type=template&id=44f3b258&scoped=true"
import script from "./MainFooterBlock.vue?vue&type=script&lang=js"
export * from "./MainFooterBlock.vue?vue&type=script&lang=js"

import "./MainFooterBlock.vue?vue&type=style&index=0&id=44f3b258&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44f3b258"]])

export default __exports__